import { connect } from 'react-redux';
import { FILTERS_PRESSURE_SENSORS } from '../../constants/SettingsKeys';

import {
    setPressureSensorsDefFilters,
    setPressureSensorsFilters,
    fetchPressureSensors,
    sortPressureSensors
} from '../../actions/SensorsActions';

import PressureSensorsSettings from '../../components/PressureSensorsSettings/PressureSensorsSettings';

const mapStateToProps = (state, ownProps) => {
  const user = state.leaksList.user;
  const {selectedProject} = state.leaksList;
  const pressureSensorsFilters = { ...state.leaksList.filters.pressureSensorsDefFilters };

  return Object.assign({}, {
    user,
    selectedProject,
    initialValues: {
      PressureSensors: pressureSensorsFilters
    },
    optionList: state.leaksList.optionList.options
  }, ownProps);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (values, dispatch, props) => {
    const {selectedProject, processFilters, cleanEmptyFilters} = props;
    const pressureSensorsFiltersObj = {...values.PressureSensors};
    const pressureSensorsFilters = processFilters(Object.assign({}, pressureSensorsFiltersObj));
    const finalPressureSensorsFilters = cleanEmptyFilters(pressureSensorsFilters.filters);

    dispatch(setPressureSensorsFilters(finalPressureSensorsFilters));
    dispatch(setPressureSensorsDefFilters(pressureSensorsFilters.defFilters));
    dispatch(sortPressureSensors(pressureSensorsFilters.sort.field, pressureSensorsFilters.sort.dir));

    dispatch(fetchPressureSensors(selectedProject));

    localStorage.setItem(FILTERS_PRESSURE_SENSORS, JSON.stringify(pressureSensorsFilters.defFilters));
  }
});

const CPressureSensorsSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(PressureSensorsSettings);

export default CPressureSensorsSettings;
